import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {

  const [cartItems, setCartItems] = useState(() => {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  });

  // Save to LocalStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  // Add to cart
  const addToCart = (newItem) => {

  const existingCart = JSON.parse(localStorage.getItem("cart")) || [];

  const existingIndex = existingCart.findIndex(item =>
    item.id === newItem.id &&
    item.variantId === newItem.variantId
  );

  if (existingIndex !== -1) {
    existingCart[existingIndex].quantity += newItem.quantity;
  } else {
    existingCart.push(newItem);
  }

  localStorage.setItem("cart", JSON.stringify(existingCart));
  setCartItems(existingCart);
};

// ✅ Clear Cart (after order success)
  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cart");
  };

  // Increase quantity
  const increaseQty = (id) => {
    setCartItems(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  // Decrease quantity
  const decreaseQty = (id) => {
    setCartItems(prev =>
      prev.map(item =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  // Remove item
  const removeItem = (id) => {
    setCartItems(prev => prev.filter(item => item.id !== id));
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        clearCart,
        increaseQty,
        decreaseQty,
        removeItem
      }}
    >
      {children}
    </CartContext.Provider>
  );
};